import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { showStoreLocatorModal } from 'actions/storeLocator'
import { getCurrentStore } from 'selectors'

const withCheckStoreAndShowStoreLocatorModal = lifecycle({
  componentDidMount() {
    if (!this.props.myStore) {
      this.props.showStoreLocatorModal()
    }
  }
})

const mapStateToProps = state => ({
  myStore: getCurrentStore(state)
})

export default compose(
  connect(mapStateToProps, { showStoreLocatorModal }),
  withCheckStoreAndShowStoreLocatorModal
)
